import { useEffect, useState } from 'react';
import { Container, Grid, Button, Typography } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ExistingRules from '../components/ExistingRules';
import { AddRuleDialog } from '../components/Dialogs/AddRuleDialog';
import { SuccessDialog } from '../components/Dialogs/SuccessDialog';
import { RulesType } from '../models/matcher.interface';
import { MatcherGroups, parseRulesResponse } from '../api/api';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridSpacer: {
      minHeight: '12px',
    },
    container: {
      padding: 20,
    },
    button: {
      margin: theme.spacing(0, 0, 0, 1),
    },
    pageTitle: {
      color: theme.palette.primary.dark,
      fontWeight: 'bold',
    },
  }),
);

export const Rules = () => {
  const classes = useStyles();
  const [rules, setRules] = useState<RulesType[]>([]);
  const [showAdd, setShowAdd] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const loadRules = () => {
    MatcherGroups.getAllMatcherGroups()
      .then((matcherGroups) => {
        setRules(matcherGroups.map(r => parseRulesResponse(r)))
      })
  }

  return (
    <Container
      component="main"
      className={classes.container}
    >
      <Grid
        container
        xs={12}
        justifyContent="space-between"
      >
        <Grid item>
          <Typography className={classes.pageTitle} variant="h6">
            Rules
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            className={classes.button}
            startIcon={<AddCircleOutlineIcon />}
            fullWidth
            type="submit"
            onClick={() => setShowAdd(true)}
          >
            Add Rule
          </Button>
        </Grid>
      </Grid>
      <Grid container className={classes.gridSpacer} />
      <Grid container spacing={0}>
        <ExistingRules
          rules={rules}
          loadRules={loadRules}
        />
      </Grid>
      <AddRuleDialog
        open={showAdd}
        onClose={() => setShowAdd(false)}
        onSuccess={() => setShowSuccess(true)}
        loadRules={loadRules}
      />
      <SuccessDialog
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        title='Add New Rule'
        content='New Rule Saved'
      />
    </Container>
  );
};

export default Rules;
